import type { CacheEntry } from "./types";

const cache = new Map<string, CacheEntry>();

export const setCache = (key: string, data: any) => {
  cache.set(key, { data, timestamp: Date.now() });
};

export const getCache = (key: string) => {
  return cache.get(key)?.data;
};

export const invalidateCache = (key: string) => {
  cache.delete(key);
};

export const clearCache = () => cache.clear();
